"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var shop_badges_1 = require("@reverbdotcom/commons/dist/components/shop_badges");
var star_rating_1 = require("@reverbdotcom/commons/dist/components/star_rating");
var url_helpers_1 = require("../shared/url_helpers");
function ListingShopModule(props) {
    var renderAchievements = function () {
        if (!props.preferredSeller && !props.quickResponder && !props.quickShipper) {
            return;
        }
        return (React.createElement("div", null,
            React.createElement("p", { className: "listing-shop-module__achievements" }, I18n.t('discovery.shop.listingModule.sellerAchievements')),
            React.createElement("div", { className: "d-flex fx-justify-center" },
                React.createElement(shop_badges_1.default, { preferredSeller: props.preferredSeller, quickResponder: props.quickResponder, quickShipper: props.quickShipper }))));
    };
    return (React.createElement("div", { className: "listing-shop-module" },
        React.createElement("div", { className: "listing-shop-module__avatar" },
            React.createElement("a", { href: url_helpers_1.default.shopPath(props.slug) },
                React.createElement("img", { src: props.avatarUrl, alt: "" }))),
        React.createElement("a", { className: "listing-shop-module__shop-name", href: url_helpers_1.default.shopPath(props.slug) }, props.shopName),
        React.createElement("a", { href: url_helpers_1.default.shopFeedbackPath(props.slug) },
            React.createElement(star_rating_1.default, { rating: props.sellerRating / 5, count: props.sellerFeedbacksCount })),
        React.createElement("p", { className: "listing-shop-module__location" }, props.location),
        React.createElement("p", { className: "listing-shop-module__joined" }, I18n.t('discovery.shop.listingModule.joined', { date: props.createdAt })),
        renderAchievements()));
}
exports.default = ListingShopModule;
//# sourceMappingURL=listing_shop_module.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/listing_shop_module.js
// module id = o4LC
// module chunks = 20 21